import CloseIcon from "@mui/icons-material/Close"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useGetSubscriptionStatusQuery } from "../../../pages/subscription/subscriptionApi"

export function SubscriptionBanner() {
  const navigate = useNavigate()
  const [isDismissed, setIsDismissed] = useState(false)
  const {
    data: subscriptionData,
    isLoading,
    error,
  } = useGetSubscriptionStatusQuery()

  // Проверяем, был ли баннер закрыт сегодня
  useEffect(() => {
    const checkDismissed = () => {
      const dismissedDate = localStorage.getItem("subscriptionBannerDismissed")
      const today = new Date().toDateString()

      // Баннер можно закрыть на текущий день для любого статуса
      if (dismissedDate === today) {
        setIsDismissed(true)
      } else {
        setIsDismissed(false)
        if (dismissedDate && dismissedDate !== today) {
          localStorage.removeItem("subscriptionBannerDismissed")
        }
      }
    }

    checkDismissed()
    if (!isLoading && subscriptionData) {
      checkDismissed()
    }
  }, [isLoading, subscriptionData])

  // Проверяем условия показа баннера
  const shouldShowBanner = () => {
    if (isLoading || error || !subscriptionData) return false

    const isPro = subscriptionData.plan?.toLowerCase() === "pro"
    const isActive =
      subscriptionData.is_active || subscriptionData.status === "active"
    const daysLeft = subscriptionData.days_left || 0

    // Если статус "none" (нет подписки)
    if (subscriptionData.status === "none" && !isDismissed) {
      return true // Показываем баннер
    }

    // Если Pro подписка и срок истек (daysLeft <= 0)
    // Проверяем только daysLeft, так как API может еще показывать isActive=true
    if (isPro && daysLeft <= 0 && !isDismissed) {
      return true // Показываем баннер
    }

    // Текущая логика: Показываем если Pro активен и осталось 3 дня или меньше
    // Проверяем isDismissed для всех случаев
    return isPro && isActive && daysLeft > 0 && daysLeft <= 3 && !isDismissed
  }

  const handleDismiss = () => {
    const today = new Date().toDateString()
    localStorage.setItem("subscriptionBannerDismissed", today)
    setIsDismissed(true)
  }

  const handleRenew = () => {
    handleDismiss()
    navigate("/subscription")
  }

  if (!shouldShowBanner()) {
    return null
  }

  const isPro = subscriptionData.plan?.toLowerCase() === "pro"
  const isActive =
    subscriptionData.is_active || subscriptionData.status === "active"
  const daysLeft = subscriptionData.days_left || 0

  // Определяем тип баннера и текст
  let bannerText = ""
  let showProBadge = false
  let showDismissButton = true // Всегда показываем кнопку закрытия

  if (subscriptionData.status === "none") {
    bannerText =
      "Перейдите на тариф PRO, чтобы активировать SMS-уведомления и пользоваться всеми функциями без ограничений."
    showProBadge = true
  } else if (isPro && daysLeft <= 0) {
    bannerText =
      "Подписка PRO истекла. Продлите, чтобы SMS-уведомления и другие функции работали."
    showProBadge = true
  } else if (isPro && isActive && daysLeft > 0 && daysLeft <= 3) {
    bannerText = `${daysLeft === 1 ? "Остался" : "Осталось"} ${daysLeft} ${daysLeft === 1 ? "день" : daysLeft < 5 ? "дня" : "дней"
      } до завершения срока подписки! Сохраните приоритетную поддержку и весь функционал.`
    showProBadge = true
    showDismissButton = true
  } else {
    return null // Не должны доходить сюда, но на всякий случай
  }

  return (
    <div className='fixed top-0 left-0 right-0 w-full bg-[#ff6b35] text-white px-4 py-3 sm:px-6 sm:py-4 z-[9999] flex items-center justify-between gap-4'>
      <div className='flex items-center gap-3 sm:gap-4 flex-1'>
        {/* Pro badge */}
        {showProBadge && (
          <div className='bg-[#1e3148] text-white px-2 py-1 rounded text-xs font-semibold flex-shrink-0'>
            Pro
          </div>
        )}

        {/* Text content */}
        <div className='flex-1'>
          <p className='m-0 text-sm sm:text-base leading-relaxed'>
            {bannerText}{" "}
            <a
              onClick={(e) => {
                e.preventDefault()
                handleRenew()
              }}
              href="#"
              className='underline font-semibold hover:no-underline inline-flex items-center gap-1 cursor-pointer'
            >
              Продлить
              <span>→</span>
            </a>
          </p>
        </div>
      </div>

      {/* Close button */}
      {showDismissButton && (
        <button
          onClick={handleDismiss}
          className='w-8 h-8 flex items-center justify-center flex-shrink-0 text-white hover:bg-white/20 rounded-full transition-colors'
          aria-label='Закрыть уведомление'
        >
          <CloseIcon sx={{ fontSize: 20 }} />
        </button>
      )}
    </div>
  )
}

